(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-help-library"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.vhlReady === '1') return;
    section.dataset.vhlReady = '1';

    var list = section.querySelector('[data-vhl-list]');
    var search = section.querySelector('[data-vhl-search]');
    var toggle = section.querySelector('[data-vhl-toggle]');
    var noResults = section.querySelector('[data-vhl-no-results]');
    var lightbox = section.querySelector('[data-vhl-lightbox]');
    var titleEl = section.querySelector('[id^="vhl-lightbox-title-"]');
    var videoEl = section.querySelector('[data-vhl-video]');
    var descEl = section.querySelector('[data-vhl-desc]');
    var closeButtons = section.querySelectorAll('[data-vhl-close]');
    var cards = section.querySelectorAll('[data-vhl-card]');
    var lastFocus = null;

    // ---- YouTube URL parser ----
    // Done client-side so we don't depend on Liquid string handling of URL fields,
    // which can vary depending on Shopify's metafield representation.
    function extractYouTubeId(url) {
      if (!url || typeof url !== 'string') return '';
      var m;
      // youtube.com/watch?v=ID  or any URL with ?v=ID/&v=ID
      m = url.match(/[?&]v=([^&#]+)/);
      if (m && m[1]) return m[1];
      // youtu.be/ID
      m = url.match(/youtu\.be\/([^?&#\/]+)/);
      if (m && m[1]) return m[1];
      // youtube.com/embed/ID  or  youtube.com/shorts/ID
      m = url.match(/youtube\.com\/(?:embed|shorts)\/([^?&#\/]+)/);
      if (m && m[1]) return m[1];
      return '';
    }

    function expandSection() {
      if (section.getAttribute('data-view') !== 'grid') {
        section.setAttribute('data-view', 'grid');
        if (toggle) toggle.setAttribute('aria-pressed', 'true');
      }
    }

    // ---- Search ----
    if (search) {
      search.addEventListener('input', function () {
        var q = (search.value || '').trim().toLowerCase();

        // Auto-expand the section as soon as the user starts searching,
        // so they see results without having to click View all first.
        if (q) expandSection();

        var visibleCount = 0;
        cards.forEach(function (card) {
          if (!q) {
            card.hidden = false;
            visibleCount++;
            return;
          }
          var hay = [
            card.dataset.title || '',
            card.dataset.description || '',
            card.dataset.keywords || '',
            card.dataset.category || ''
          ].join(' ').toLowerCase();
          var match = hay.indexOf(q) !== -1;
          card.hidden = !match;
          if (match) visibleCount++;
        });
        if (noResults) noResults.hidden = visibleCount > 0;
      });
    }

    // ---- View toggle (row <-> grid) ----
    if (toggle) {
      toggle.addEventListener('click', function () {
        var current = section.getAttribute('data-view');
        var next = current === 'grid' ? 'row' : 'grid';
        section.setAttribute('data-view', next);
        toggle.setAttribute('aria-pressed', next === 'grid' ? 'true' : 'false');
      });
    }

    // ---- Card click / keyboard ----
    cards.forEach(function (card) {
      card.addEventListener('click', function () { openCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openCard(card);
        }
      });
    });

    function openCard(card) {
      lastFocus = document.activeElement;
      var title = card.dataset.title || '';
      var description = card.dataset.description || '';
      var ytId = extractYouTubeId(card.dataset.youtubeUrl || '');

      if (titleEl) titleEl.textContent = title;
      if (descEl) descEl.textContent = description;

      if (videoEl) {
        if (ytId) {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytId) + '?autoplay=1&rel=0&modestbranding=1';
          iframe.title = title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.setAttribute('allowfullscreen', '');
          videoEl.innerHTML = '';
          videoEl.appendChild(iframe);
        } else {
          videoEl.innerHTML = '';
        }
      }

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var firstFocusable = lightbox.querySelector('.vhl__lightbox-close');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      if (videoEl) videoEl.innerHTML = ''; // hard-stop the video
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    // Simple focus trap inside lightbox
    lightbox.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !lightbox.classList.contains('is-open')) return;
      var focusables = lightbox.querySelectorAll(
        'button, [href], iframe, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vhl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section load (theme editor live preview)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-vhl]');
    if (section) init(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-help-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.vhpReady === '1') return;
    section.dataset.vhpReady = '1';

    var search = section.querySelector('[data-vhp-search]');
    var grid = section.querySelector('[data-vhp-grid]');
    var noResults = section.querySelector('[data-vhp-no-results]');
    var chips = section.querySelectorAll('[data-vhp-chip]');
    var lightbox = section.querySelector('[data-vhp-lightbox]');
    var titleEl = section.querySelector('[id^="vhp-lightbox-title-"]');
    var videoEl = section.querySelector('[data-vhp-video]');
    var descEl = section.querySelector('[data-vhp-desc]');
    var closeButtons = section.querySelectorAll('[data-vhp-close]');
    var cards = section.querySelectorAll('.vhp__card');
    var lastFocus = null;

    var state = {
      query: '',
      category: ''
    };

    function extractYouTubeId(url) {
      if (!url || typeof url !== 'string') return '';
      var m;
      m = url.match(/[?&]v=([^&#]+)/);
      if (m && m[1]) return m[1];
      m = url.match(/youtu\.be\/([^?&#\/]+)/);
      if (m && m[1]) return m[1];
      m = url.match(/youtube\.com\/(?:embed|shorts)\/([^?&#\/]+)/);
      if (m && m[1]) return m[1];
      return '';
    }

    function applyFilter() {
      var q = state.query;
      var cat = state.category;
      var visibleCount = 0;

      cards.forEach(function (card) {
        // Featured cards live in two places (the featured row and the grid).
        // Search and category filtering only target grid cards — featured ones stay
        // visible regardless. Distinguish by data-grid-card attribute.
        var isGridCard = card.dataset.gridCard === '1';
        if (!isGridCard) return;

        var titleStr = (card.dataset.title || '').toLowerCase();
        var descStr = (card.dataset.description || '').toLowerCase();
        var keywordsStr = (card.dataset.keywords || '').toLowerCase();
        var categoryStr = card.dataset.category || '';

        var matchSearch = !q || (titleStr + ' ' + descStr + ' ' + keywordsStr + ' ' + categoryStr.toLowerCase()).indexOf(q) !== -1;
        var matchCategory = !cat || categoryStr === cat;

        var show = matchSearch && matchCategory;
        card.hidden = !show;
        if (show) visibleCount++;
      });

      if (noResults) noResults.hidden = visibleCount > 0;
    }

    if (search) {
      search.addEventListener('input', function () {
        state.query = (search.value || '').trim().toLowerCase();
        applyFilter();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        state.category = chip.dataset.category || '';
        applyFilter();
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () { openCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openCard(card);
        }
      });
    });

    function openCard(card) {
      lastFocus = document.activeElement;
      var title = card.dataset.title || '';
      var description = card.dataset.description || '';
      var ytId = extractYouTubeId(card.dataset.youtubeUrl || '');

      if (titleEl) titleEl.textContent = title;
      if (descEl) descEl.textContent = description;

      if (videoEl) {
        if (ytId) {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytId) + '?autoplay=1&rel=0&modestbranding=1';
          iframe.title = title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.setAttribute('allowfullscreen', '');
          videoEl.innerHTML = '';
          videoEl.appendChild(iframe);
        } else {
          videoEl.innerHTML = '';
        }
      }

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var firstFocusable = lightbox.querySelector('.vhp__lightbox-close');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      if (videoEl) videoEl.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    lightbox.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !lightbox.classList.contains('is-open')) return;
      var focusables = lightbox.querySelectorAll(
        'button, [href], iframe, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vhp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-vhp]');
    if (section) init(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
